<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-3">
        <table class="table table-sm table-bordered">
          <colgroup>
            <col style="width: 50%">
            <col style="width: 50%">
          </colgroup>
          <tr>
            <th class="text-center font-weight-normal">
              Configurar
            </th>
            <td class="text-center">
              <b-form-checkbox
                id="checkbox-holidays"
                class="d-inline"
                v-model="itemData.enableHolidays"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group label="Año">
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="itemData.holidaysFromApi.year"
            :options="years"
            :reduce="(val) => val.value"
            append-to-body
            :disabled="disabledInputsHlidays"
            :clearable="false"
            :calculate-position="withPopper"
            @input="$emit('get-holidays')"
          />
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group label="Mes">
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="itemData.holidaysFromApi.month"
            :options="months"
            :reduce="(val) => val.value"
            append-to-body
            :disabled="disabledInputsHlidays"
            :clearable="false"
            :calculate-position="withPopper"
            @input="calendarInit()"
          />
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group label="Tipo de selección">
          <v-select
            v-model="selection"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :disabled="disabledInputsHlidays"
            :options="selectionTypes"
            :clearable="false"
            :reduce="(val) => val.value"
            placeholder="Seleccionar tipo"
          >
            <template #selected-option="option">
              <div class="d-flex align-items-center">
                <div :style="{
                  height: '22px',
                  width: '22px',
                  borderRadius: '3px',
                  background: option.color,
                  border: `1px solid ${((!option.value) ? '#dcdcdc' : option.color)}`
                }"></div>
                <span class="ml-1">{{ option.label }}</span>
              </div>
            </template>
            <template v-slot:option="option">
              <div class="d-flex align-items-center">
                <div :style="{
                  height: '22px',
                  width: '22px',
                  borderRadius: '3px',
                  background: option.color,
                  border: `1px solid ${((!option.value) ? '#dcdcdc' : option.color)}`
                }"></div>
                <span class="ml-1">{{ option.label }}</span>
              </div>
            </template>
          </v-select>
        </b-form-group>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-9">
        <div class="calendar-header">
          <div v-for="day in days" :key="day.value" class="day-name">
            {{ day.label.substring(0, 3) }}
          </div>
        </div>
        <div class="calendar-body">
          <div
            v-for="item in calendar"
            :key="item.date.getTime()"
            class="calendar-day"
            :class="{
              'other-month': (!item.currentMonth || !itemData.enableHolidays),
              'selected': item.selected,
              'selecting': isDragging && isInSelection(item)
            }"
            @mousedown.prevent="startSelection(item)"
            @mouseenter="moveSelection(item)"
            @mouseup="endSelection"
          >
            {{ item.day }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed,onMounted,ref } from "@vue/composition-api";
import popperHelper from "@/libs/popper-helper";
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  props: {
    itemData: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  setup(props, { emit }) {
    //HOOSK
    onMounted(() => {
      setHolidaysFromApi();
      initDates();
  });

    //DATA
    const calendar = ref([]);

    const currentYear = ref(null);

    const days = [
      { value: 0, label: 'Domingo' },
      { value: 1, label: 'Lunes' },
      { value: 2, label: 'Martes' },
      { value: 3, label: 'Miercoles' },
      { value: 4, label: 'Jueves' },
      { value: 5, label: 'Viernes' },
      { value: 6, label: 'Sabado' }
    ];

    const daysInMonth = ref(null);

    const dragStart = ref(null);

    const dragEnd = ref(null);

    const firstDate = ref(null);

    const firstDayWeek = ref(null);

    const isDragging = ref(false);

    const months = [
      { label: "Enero", value: 0 },
      { label: "Febrero", value: 1 },
      { label: "Marzo", value: 2 },
      { label: "Abril", value: 3 },
      { label: "Mayo", value: 4 },
      { label: "Junio", value: 5 },
      { label: "Julio", value: 6 },
      { label: "Agosto", value: 7 },
      { label: "Septiembre", value: 8 },
      { label: "Octubre", value: 9 },
      { label: "Noviembre", value: 10 },
      { label: "Diciembre", value: 11 },
    ];

    const previousMonthDays = ref(null);

    const selection = ref(true);

    const selectionTypes = ref([
      {
        value: true,
        label: 'Agregar',
        color: '#05DF72',
      },
      {
        value: false,
        label: 'Quitar',
        color: '#FFF',
      }
    ]);

    const year = ref(null);

    const years = ref([]);

    //COMPUTED
    const disabledInputsHlidays = computed(() => (!props.itemData.enableHolidays || props.loading))

    //METHODS
    const calendarInit = () => {
      const year  = props.itemData.holidaysFromApi.year;
      const month = props.itemData.holidaysFromApi.month;

      calendar.value     = [];
      daysInMonth.value  = new Date(year, (month + 1), 0).getDate();
      firstDate.value    = new Date(year, month, 1);
      firstDayWeek.value = firstDate.value.getDay();
      previousMonthDays.value = new Date(year, month, 0).getDate();


      for (let i = firstDayWeek.value; i > 0; i--) {
        const day = previousMonthDays.value - i + 1;
        const date = new Date(year, (month - 1), day);
        const index = calendar.value.length;

        calendar.value.push({
          row: Math.floor(index / 7),
          col: index % 7,
          date,
          year: year,
          month: (month + 1),
          day,
          weekDay: date.getDay(),
          weekDayName: days[date.getDay()].label,
          currentMonth: false,
          selected: false,
          fromApi: false
        });
      }

      for (let day = 1; day <= daysInMonth.value; day++) {
        const index = calendar.value.length;
        const date = new Date(year, month, day);
        const selectedDay = findSelectedDay(year, (month + 1), day);

        calendar.value.push({
          row: Math.floor(index / 7),
          col: index % 7,
          date,
          year: year,
          month: (month + 1),
          day,
          weekDay: date.getDay(),
          weekDayName: days[date.getDay()].label,
          currentMonth: true,
          selected: (selectedDay) ? selectedDay.selected : false,
          fromApi: (selectedDay) ? selectedDay.fromApi : false
        });
      }

      let nextDay = 1;

      while (calendar.value.length < 42) {
        const index = calendar.value.length;
        const date = new Date(year, (month + 1), nextDay);

        calendar.value.push({
          row: Math.floor(index / 7),
          col: index % 7,
          date,
          year: year,
          month: (month + 1),
          day: nextDay,
          weekDay: date.getDay(),
          weekDayName: days[date.getDay()].label,
          currentMonth: false,
          selected: false,
          fromApi: false
        });

        nextDay++;
      }
    }

    const endSelection = () => {
      if (!isDragging.value) {
        return;
      }

      paintSelection();

      isDragging.value = false;
      dragStart.value = null;
      dragEnd.value = null;
    }

    const findSelectedDay = (year, month, day) => {
      return props.itemData.selectedDays.find(selectedDay =>
        selectedDay.year === year &&
        selectedDay.month === month &&
        selectedDay.day === day
      );
    }

    const findSelectedDayIndex = (day) => {
      return props.itemData.selectedDays.findIndex(selectedDay =>
        selectedDay.year === day.year &&
        selectedDay.month === day.month &&
        selectedDay.day === day.day
      );
    }

    const initDates = () => {
      const date = new Date();

      currentYear.value = date.getFullYear();
      //month.value       = date.getMonth();
      //year.value        = props.itemData.holidaysFromApi.year;

      years.value = Array.from({ length: 11 }, (_, i) => ({
          label: String(currentYear.value + i),
          value: currentYear.value + i,
      }));

      calendarInit();
    }

    const isInSelection = (item) => {
      if (!dragStart.value || !dragEnd.value) {
        return false;
      }

      const minRow = Math.min(
        dragStart.value.row,
        dragEnd.value.row
      );

      const maxRow = Math.max(
        dragStart.value.row,
        dragEnd.value.row
      );

      const minCol = Math.min(
        dragStart.value.col,
        dragEnd.value.col
      );

      const maxCol = Math.max(
        dragStart.value.col,
        dragEnd.value.col
      );

      return (
        item.row >= minRow &&
        item.row <= maxRow &&
        item.col >= minCol &&
        item.col <= maxCol
      );
    }

    const moveSelection = (item) => {
      if (!isDragging.value) {
        return;
      }

      dragEnd.value = {
        row: item.row,
        col: item.col
      }
    }

    const startSelection = (item) => {
      if (!item.currentMonth || !props.itemData.enableHolidays) {
        return;
      }

      isDragging.value = true;

      dragStart.value = {
        row: item.row,
        col: item.col
      };

      dragEnd.value = {
        row: item.row,
        col: item.col
      };
    }

    const paintSelection = () => {
      if (!dragStart.value || !dragEnd.value) {
        return;
      }

      const minRow = Math.min(dragStart.value.row, dragEnd.value.row);
      const maxRow = Math.max(dragStart.value.row, dragEnd.value.row);
      const minCol = Math.min(dragStart.value.col, dragEnd.value.col);
      const maxCol = Math.max(dragStart.value.col, dragEnd.value.col);

      calendar.value.forEach(day => {
        const isInsideRectangle = (day.row >= minRow) && (day.row <= maxRow) && (day.col >= minCol) && (day.col <= maxCol);

        if (!day.currentMonth || !isInsideRectangle) {
          return;
        }

        const selectedDayIndex = findSelectedDayIndex(day);

        day.selected = selection.value;

        if (selection.value) {
          if (selectedDayIndex === -1) {
            props.itemData.selectedDays.push({
              year: day.year,
              month: day.month,
              day: day.day,
              selected: true,
              fromApi: false
            });
          } else {
            const dataDay = {
              ...props.itemData.selectedDays[selectedDayIndex],
              selected: true
            }

            props.itemData.selectedDays.splice(selectedDayIndex, 1, dataDay);
          }

          return;
        }

        if (selectedDayIndex === -1) {
          return;
        }

        const selectedDay = props.itemData.selectedDays[selectedDayIndex];

        if (selectedDay.fromApi) {
          const dataDay = {
            ...selectedDay,
            selected: false
          }

          props.itemData.selectedDays.splice(selectedDayIndex, 1, dataDay);
        } else {
          props.itemData.selectedDays.splice(selectedDayIndex, 1);
        }
      });
    }

    const setHolidaysFromApi = () => {
      const holidaysFromApi = props.itemData.holidaysFromApi;
      const monthsWithHolidays = holidaysFromApi.month_wise_holidays.filter(mwh => (mwh.Holiday.length));

      props.itemData.selectedDays = [];

      if (monthsWithHolidays.length) {
        monthsWithHolidays.forEach(mwh => {
          mwh.Day.forEach(day => {
            props.itemData.selectedDays.push({
              year: holidaysFromApi.year,
              month: mwh.Month,
              day: Number(day),
              selected: true,
              fromApi: true
            });
          });
        });
      }
    }

    return {
      calendar,
      currentYear,
      days,
      isDragging,
      months,
      selection,
      selectionTypes,
      withPopper: popperHelper.withPopper,
      year,
      years,

      disabledInputsHlidays,

      calendarInit,
      endSelection,
      initDates,
      isInSelection,
      moveSelection,
      setHolidaysFromApi,
      startSelection
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-header, .calendar-body {
  display:grid;
  grid-template-columns:repeat(7,1fr);
}

.day-name {
  text-align:center;
  font-weight:bold;
  padding:10px 0;
}

.day-name {
    text-align:center;
    font-weight:bold;
    padding:10px 0;
}

.calendar-day {
  height:35px;
  border:1px solid #E9ECEF;
  display:flex;
  justify-content:center;
  align-items:center;

  cursor:pointer;
}

.other-month {
  color:#B8B8B8;
  background:#F8F9FA;
  cursor: not-allowed;
}

.selected {
  background:#05DF72;
  color:white;
}

.selecting {
  outline: 1px solid #1b3d53;
  outline-offset: -1px;
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
